import type {StateCreator} from 'zustand'
import type {Codeowners} from '../../page-data/payloads/codeowners'

export type CodeownersSlice = {
  codeowners?: Codeowners
  codeownersActions: {
    setCodeowners: (codeowners?: Codeowners) => void
  }
}

export const createCodeownersSlice =
  (): StateCreator<CodeownersSlice, [['zustand/devtools', never]]> => (set, _get) => ({
    codeowners: undefined,
    codeownersActions: {
      setCodeowners: (codeowners?: Codeowners) => {
        set({codeowners}, undefined, 'updateCodeowners')
      },
    },
  })
